export default {
  BASE_URL: '',
  FRIDAY_TRACKER_ID: 'ecb6c2aa9c4d4b9d95b0563a322dd245',
  // 高德地图安全代理（已弃用，保留用于回滚）
  AMAP_SERCURITY_HOST: `${location.origin}/_AMapService`,
};



// WEBPACK FOOTER //
// ./src/config/config.dev.js